<div class="footer_layout">
    <img src="Logo_Small.png" alt="Company Logo" class="logo-image" />
    <div class="footer-text-container">
        <span class="separator">|</span>
        <a routerLink="/conditions-of-use-and-sale" routerLinkActive="active-link" class="footer-link">
            {{'footer.terms-of-use' | translate}}
        </a>
        <a routerLink="/privacy-notice" routerLinkActive="active-link" class="footer-link">
            {{'footer.privacy' | translate}}
        </a>
        <a routerLink="/imprint" routerLinkActive="active-link" class="footer-link">
            {{'footer.imprint' | translate}}
        </a>
    </div>
    <div class="footer-rights-container">
        <p><span>©</span>
            {{'footer.copyright' | translate}}</p>
    </div>
</div>